import React, { useState } from "react";
import AuthLayout from "layouts/AuthLayout";
import { AppPasswordInput, Button } from "components";
import { toast } from "react-hot-toast";
import { ApiService } from "services";
import { Router } from "utils/route";
// import { arrow } from "assets/icons";
const CreatePassword = () => {
  const [oldPassword, setOldPassword] = useState();
  const [newPassword, setNewPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [loader, setLoader] = useState(false);
  const { route } = Router();

  const changePassword = async () => {
    if (newPassword === confirmPassword) {
      setLoader(true);
      try {
        const data = await ApiService.changePassword({
          userId: localStorage.getItem("user_id"),
          oldPassword: oldPassword,
          newPassword: newPassword,
          confirmPassword: confirmPassword,
        });
        console.log(data);
        setLoader(false);
        route("/");
        toast.success(data?.message);
      } catch (err) {
        console.log(err);
        setLoader(false);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    } else {
      toast.error("New Passwords have to match");
    }
  };
  return (
    <div>
      <AuthLayout
        submit={(e) => {
          e.preventDefault();
          console.log("eeee");
          changePassword();
        }}
        title="Change Generated Password"
      >
        <AppPasswordInput
          onChange={(e) => {
            setOldPassword(e.target.value);
          }}
          placeholder="Enter Generated Password"
        />
        <AppPasswordInput
          onChange={(e) => {
            setNewPassword(e.target.value);
          }}
          placeholder="Enter New Password"
        />
        <AppPasswordInput
          onChange={(e) => {
            setConfirmPassword(e.target.value);
          }}
          placeholder="Confirm New Password"
        />

        <Button loading={loader} disabled={loader} placeholder="Proceed" />
      </AuthLayout>
    </div>
  );
};

export default CreatePassword;
